/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScoreEvidenceInput
 */
export interface ScoreEvidenceInput {
    /**
     * Must match the persisted EvidenceType enum exactly.
     * @type {string}
     * @memberof ScoreEvidenceInput
     */
    type?: ScoreEvidenceInputTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ScoreEvidenceInput
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof ScoreEvidenceInput
     */
    description?: string;
}


/**
 * @export
 */
export const ScoreEvidenceInputTypeEnum = {
    SCREENSHOT: 'SCREENSHOT',
    VIDEO: 'VIDEO',
    OVERWOLF_DATA: 'OVERWOLF_DATA'
} as const;
export type ScoreEvidenceInputTypeEnum = typeof ScoreEvidenceInputTypeEnum[keyof typeof ScoreEvidenceInputTypeEnum];


/**
 * Check if a given object implements the ScoreEvidenceInput interface.
 */
export function instanceOfScoreEvidenceInput(value: object): value is ScoreEvidenceInput {
    return true;
}

export function ScoreEvidenceInputFromJSON(json: any): ScoreEvidenceInput {
    return ScoreEvidenceInputFromJSONTyped(json, false);
}

export function ScoreEvidenceInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScoreEvidenceInput {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'url': json['url'] == null ? undefined : json['url'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function ScoreEvidenceInputToJSON(json: any): ScoreEvidenceInput {
    return ScoreEvidenceInputToJSONTyped(json, false);
}

export function ScoreEvidenceInputToJSONTyped(value?: ScoreEvidenceInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'url': value['url'],
        'description': value['description'],
    };
}

